module.exports = __webpack_public_path__ + "static/img/hd-3.5ff264e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hd-3.jpg
// module id = 550
// module chunks = 2